export { default } from './AvatarPlaceholder';
